import React from 'react';
import { Dialog } from '@mui/material';
import styles from '../../../custom/style.module.css';
import { CustomButton, CustomTextField, CustomDialogTitle, CustomDialogAction, CustomInputLabel, StyledCard, InputProps, CustomDialogContent } from '../../../custom/components';
import { CloseIconBtn } from 'custom/constants';

const RemarkModal = (props) => {
  const { remark } = props;
  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={props.modal === 'remark'} onClose={props.onClose}>
        <CustomDialogTitle id='form-dialog-title'>
          Remarks
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        <form className={styles.w100}>
          <CustomDialogContent sx={{ width: 600 }}>
            <StyledCard>
              <div>
                <CustomInputLabel htmlFor='Remark' className={styles.pl0}>Remark</CustomInputLabel>
                <CustomTextField
                  {...InputProps}
                  fullWidth
                  id='deactivate'
                  className={`${styles.mb3}`}
                  placeholder='Add Reason'
                  type='text'
                  rows={'3'}
                  multiline
                  name='reason'
                  disabled
                  value={remark || ''}
                />
              </div>
            </StyledCard>
          </CustomDialogContent>
          <CustomDialogAction sx={{ justifyContent: 'flex-end' }}>
            <CustomButton variant='contained' onClick={props.onClose}>Close</CustomButton>
          </CustomDialogAction>
        </form>
      </Dialog>
    </div>
  );
};
export default RemarkModal;